import common from "./en-US/common.json";
import post from "./en-US/post.json";
import movie from "./en-US/movie.json";

export const resources = {
    "en-US": {
        common,
        post,
        movie
    },
} as const;

export default resources;